import ikPrice from '@infomaniak/currency';
import { AppReadyMessageKey, BridgeConnected, KSuiteBridge } from '@infomaniak/ksuite-bridge';
import { SpaceShortcutTask } from './task/space-shortcut.task';
import { WCObserver } from './utils/observer';
import { WCPipes } from './utils/pipes';
import { WCServices } from './utils/services';
import { WCTranslate } from './utils/translate';
import { WCUtils } from './utils/utils';
class Common {
    constructor() {
        this.myObserver = new WCObserver();
        this.myTranslate = new WCTranslate(this.myObserver);
        this.apiEndpoint = this.getApiEndpoint();
        this.loadingProductsRouting = false;
        this.currentEvents = [];
        this.userGroups = [];
        this.products = [];
        this.ikPrice = ikPrice;
        this.serviceData = new WCServices();
        this.pipes = new WCPipes();
        this.utils = new WCUtils();
        this.ksuiteBridge = undefined;
        this.theme = 'light';
        this.loaderOBject = {};
        this.timeLoadingOBject = {};
        this.theming();
        this.setConfig();
        if (window['CURRENT_PROJECT'] !== 'ksuite') {
            this.ksuiteBridge = new KSuiteBridge();
        }
        this.ksuiteBridge?.on(BridgeConnected, () => this.initKsuiteGlobalBehaviors());
        if (window['CURRENT_PROJECT'] === 'local')
            void this.ksuiteBridge?.sendMessage({ type: AppReadyMessageKey });
    }
    /**
     * This function iterate on a task array and enable them. Those tasks are related to the ksuite.
     */
    initKsuiteGlobalBehaviors() {
        [SpaceShortcutTask].forEach((task) => task.enable());
    }
    setConfig() {
        const config = window['config2'] || {};
        const { url: productsRouting = {}, user: userStartConfig = {}, groups: groupsStartConfig = {}, current_account: currentAccount = {}, current_space: currentSpace = {}, current_events: currentEvents = [], } = config;
        this.productsRouting = productsRouting;
        this.userStartConfig = userStartConfig;
        this.groupsStartConfig = groupsStartConfig;
        this.currentAccount = currentAccount;
        this.currentSpace = currentSpace;
        this.currentEvents = currentEvents;
        window['config2'] = null;
        if (window['WC_TOKEN']) {
            this.wcToken = window['WC_TOKEN'];
            window['WC_TOKEN'] = null;
        }
    }
    getApiEndpoint() {
        if (window['WEB_COMPONENT_API_ENDPOINT']) {
            return window['WEB_COMPONENT_API_ENDPOINT'];
        }
        else {
            if (window.location.href.includes('infomaniak.ch')) {
                const urlStart = window.location.host.split('.');
                urlStart.shift();
                return window.location.protocol + '//welcome.' + urlStart.join('.');
            }
            else {
                return process.env.WEB_COMPONENT_API_ENDPOINT;
            }
        }
    }
    translate(...args) {
        return this.myTranslate.translate(...args);
    }
    getLang() {
        return this.myTranslate.getLang();
    }
    addObserver(topic, observer) {
        return this.myObserver.addObserver(topic, observer);
    }
    removeObserver(topic, observer) {
        return this.myObserver.removeObserver(topic, observer);
    }
    notifyObservers(topic, message) {
        return this.myObserver.notifyObservers(topic, message);
    }
    theming() {
        // Target element that will be observed
        const target = document.body;
        const getTheme = target.className.match(/light|medium|dark/g);
        this.theme = getTheme?.[0] === 'dark' ? 'dark' : 'light';
        // Init theming
        this.notifyObservers('theme', this.theme);
        const config = {
            attributes: true,
            attributeOldValue: false,
            attributeFilter: ['class'],
        };
        const subscriberCallback = (mutations) => {
            const getMutationsTheme = mutations[mutations.length - 1].target.className.match(/light|medium|dark/g);
            this.theme = getMutationsTheme?.[0] === 'dark' ? 'dark' : 'light';
            this.notifyObservers('theme', this.theme);
        };
        const observer = new MutationObserver(subscriberCallback);
        observer.observe(target, config);
    }
    loaderStart(key) {
        this.timeLoadingOBject[key] = Date.now();
    }
    async loaderStop(key, duration = 500) {
        if (!this.timeLoadingOBject[key]) {
            return;
        }
        const remainingTime = Date.now() - this.timeLoadingOBject[key];
        if (remainingTime >= duration) {
            delete this.timeLoadingOBject[key];
            return false;
        }
        else {
            await new Promise((resolve) => setTimeout(() => {
                delete this.timeLoadingOBject[key];
                resolve(false);
            }, duration - remainingTime));
        }
    }
}
window['webComponentsStore'] = new Common();
